/**
 * <pre>
 * 어드민에서 자주 사용하는 상수 형태로 select 요소에 사용할 옵션 리스트를 생성하는 함수
 * ex) makeSelectOptionList(Object.values(PRODUCT_STATUS_STR), PRODUCT_STATUS_TEXT)
 * </pre>
 */
const makeSelectOptionList = (keys: (string | number)[], optionValues: { [key: string]: string }) => {
  return [
    { id: null, name: '전체' },
    ...keys
      .filter((key) => key in optionValues)
      .map((key) => ({
        id: key,
        name: optionValues[key as string],
      })),
  ];
};
export default makeSelectOptionList;
